import React, { useRef } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import maskMap from "./textures/logo-MASKA-inv.jpg"

export function VuseModel(props) {
  const vuse = useRef(null)
  const { nodes, materials } = useGLTF('/data/vuse_go_export3.glb')

  const colorMap = [
    {
      body: "#EE6B4D",
      bottom: "#D39189",
      logo: "#CE331C"
    },
    {
      body: "#587080",
      bottom: "#658298",
      logo: "#adc2d5"
    },
    {
      body: "#ebb045",
      bottom: "#dec695",
      logo: "#d96e21"
    },
    {
      body: "#3984e0",
      bottom: "#52b7ef",
      logo: "#15429e"
    }
  ]

  useFrame(({clock}) => {
    vuse.current.rotation.y = clock.getElapsedTime()/3
  })

  const [vusemaskMap] = useTexture([
    maskMap
  ])

  vusemaskMap.flipY = false

  return (
      <group ref={vuse} {...props} dispose={null} scale={0.2} rotation={[0, -Math.PI/4, 0]}> //rotation={[-Math.PI/16, Math.PI/8, Math.PI/16]}
        <group rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Box015.geometry}
            material={materials['Material.001']}
            position={[-0.438, 0.006, 0]}
          />
          <group position={[-10.233, -0.212, -0.007]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Mesh003.geometry}
              material={materials['Material #20']}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Mesh003_1.geometry}
              material={materials['Material #32']}
            />
          </group>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.SWIATELKO.geometry}
            material={materials.led}
            position={[-5.566, -0.609, 0]}
          >
            <meshStandardMaterial 
              // map={texture4}
              color={"#0f0"}
              transparent 
              metalness={0.3}
              roughness={0.5}
            />
          </mesh>
        </group>
        <group rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
          <group position={[-5.566, -0.615, 0]}>
            {/* // body */}
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Mesh004.geometry}
            >
              <meshStandardMaterial 
                attach={"material"}
                // map={texture4}
                color={colorMap[0].body}
                metalness={0.5}
                roughness={0.35}
              />
            </mesh>
            <mesh
              scale={1.0}
                castShadow
                receiveShadow
                geometry={nodes.Mesh004.geometry}
              >
              <meshStandardMaterial 
                alphaMap={vusemaskMap}
                color={colorMap[0].logo}
                transparent 
                metalness={0.7}
                roughness={0.1}
              />
            </mesh>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Mesh004_1.geometry}
              material={materials.BODY_DOL}
            >
              <meshStandardMaterial 
                // map={texture4}
                color={colorMap[0].bottom}
                transparent 
                metalness={0.5}
                roughness={0.2}
              />
            </mesh>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Mesh004_2.geometry}
              material={materials['Material #18']}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Mesh004_3.geometry}
              material={materials.chrom}
            />
          </group>
        </group>
      </group>
  )
}

// // useGLTF.preload('/data/vuse_go_export3.glb')